/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PeriodoRendicontazioneStatus } from './periodo-rendicontazione-status';


export interface PeriodoRendicontazioneDTO { 
    id?: string;
    data_inizio?: string;
    data_fine?: string;
    data_attivazione?: string;
    status?: PeriodoRendicontazioneStatus;
}



